<section class="bg-gray padding-60px-tb xs-padding-60px-tb" id="portfolio">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-12 text-center">
                <h2
                    class="section-title-large sm-section-title-medium xs-section-title-large text-servios font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom">
                    Nuestros trabajos</h2>
                <!--  <div
                    class="text-medium width-60 margin-lr-auto md-width-70 sm-width-100 margin-seven-bottom xs-margin-nineteen-bottom">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book.</div> -->
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="work-3col wide gutter">
                    <div class="overflow-hidden grid-gallery">
                        <div class="tab-content">
                            <ul class="masonry-items grid work-gallery grid">
                                <!-- portfolio item -->
                                <li class="html jquery xs-no-padding  wow fadeInUp">
                                    <figure>
                                        <div class="gallery-img lightbox-gallery">
                                            <a href="assets/image/galeria/1.jpg" title=""><img
                                                    src="assets/image/galeria/1.jpg" alt=""></a>
                                        </div>
                                    </figure>
                                </li>
                                <!-- end portfolio item -->
                                <!-- portfolio item -->
                                <li class="magento wordpress xs-no-padding  wow fadeInUp">
                                    <figure>
                                        <div class="gallery-img lightbox-gallery">
                                            <a href="assets/image/galeria/2.jpg" title=""><img
                                                    src="assets/image/galeria/2.jpg" alt=""></a>
                                        </div>
                                    </figure>
                                </li>
                                <!-- end portfolio item -->
                                <!-- portfolio item -->
                                <li class="jquery xs-no-padding wow fadeInUp">
                                    <figure>
                                        <div class="gallery-img lightbox-gallery">
                                            <a href="assets/image/galeria/3.jpg" title=""><img
                                                    src="assets/image/galeria/7.jpg" alt=""></a>
                                        </div>
                                    </figure>
                                </li>
                                <!-- end portfolio item -->
                                <!-- portfolio item -->
                                <li class="html magento jquery xs-no-padding  wow fadeInUp">
                                    <figure>
                                        <div class="gallery-img lightbox-gallery">
                                            <a href="assets/image/galeria/4.jpg" title=""><img
                                                    src="assets/image/galeria/4.jpg" alt=""></a>
                                        </div>
                                    </figure>
                                </li>
                                <!-- end portfolio item -->
                                <!-- portfolio item -->
                                <li class="html wordpress magento xs-no-padding  wow fadeInUp">
                                    <figure>
                                        <div class="gallery-img lightbox-gallery">
                                            <a href="assets/image/galeria/5.jpg" title=""><img
                                                    src="assets/image/galeria/5.jpg" alt=""></a>
                                        </div>
                                    </figure>
                                </li>
                                <!-- end portfolio item -->
                                <!-- portfolio item -->
                                <li class="wordpress html xs-no-padding  wow fadeInUp">
                                    <figure>
                                        <div class="gallery-img lightbox-gallery">
                                            <a href="assets/image/galeria/6.jpg" title=""><img
                                                    src="assets/image/galeria/6.jpg" alt=""></a>
                                        </div>
                                    </figure>
                                </li>
                                <!-- end portfolio item -->


                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center padding-40px-tb">
            <div class="col-lg-2 col-md-2 col-6 text-center">
                <button type="button" [routerLink]="['/servicio', 1]"
                    class="btn btn-large btn-block bg-red btn-3d text-white text-center">VER MÁS
                </button>
            </div>
        </div>
    </div>
</section>